import { DataProvider, addRefreshAuthToDataProvider } from 'react-admin'
import { beseDataProvider } from './base/base-provider'
import { baseResources } from './base/base-resources'
import { mstResources } from './mst/mst-resources'
import { mstDataProvider } from './mst/mst-provider'
import combinedProvider from './combined-provider'
import tokenManager from '../../utils/token'
const initDataProvider = (): DataProvider => {
  const dataProviders = [
    // * Examples for multiple data provider implementation
    // { dataProvider: jsonServerProvider('https://jsonplaceholder.typicode.com'), resources: ['comments'] },
    {
      dataProvider: beseDataProvider(baseResources),
      resources: Object.keys(baseResources),
    },
    {
      dataProvider: mstDataProvider(mstResources),
      resources: Object.keys(mstResources),
    },
  ]
  return addRefreshAuthToDataProvider(combinedProvider(dataProviders), tokenManager.validateToken)
}
export default initDataProvider
